<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />
      <div class="layout-container">
        <app-layout-navbar />
        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1">
            <router-view />
            <router-view name="modalView" />
            <project-filters :visible="sidebarIsVisible" />
            <user-select-modal />
          </div>
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayoutNavbar from './LayoutNavbar';
import LayoutSidenav from './LayoutSidenav';
import ProjectFilters from '@/views/projects/ProjectFilters';
import UserSelectModal from '@/components/users/UserSelectModal';

export default {
  name: 'AppLayout',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    ProjectFilters,
    UserSelectModal,
  },

  computed: {
    ...mapGetters('projects', ['sidebarIsVisible']),
  },

  mounted() {
    this.layoutHelpers.init();
    this.layoutHelpers.update();
    this.layoutHelpers.setAutoUpdate(true);
    this.layoutHelpers.setCollapsed(true);
  },

  beforeDestroy() {
    this.layoutHelpers.destroy();
  },

  methods: {
    closeSidenav() {
      this.layoutHelpers.setCollapsed(true);
    },
  },
};
</script>
